import * as types from '@/constants/mutationTypes'

const state = {
  requestsList: [],
  requestsListDeclined: [],
  requestsListForward: [],
  listOfRequestTags: []
}
const getters = {
  requestsList: state => state.requestsList,
  requestsListDeclined: state => state.requestsListDeclined,
  requestsListForward: state => state.requestsListForward,
  listOfRequestTags: state => state.listOfRequestTags
}
const actions = {
  setRequestsList ({commit}, data) {
    commit(types.SET_REQUESTS_LIST, {data})
  },
  setRequestsListDeclined ({commit}, data) {
    commit(types.SET_REQUESTS_LIST_DECLINED, {data})
  },
  setRequestsListForward ({commit}, data) {
    commit(types.SET_REQUESTS_LIST_FORWARD, {data})
  },
  setListOfRequestTags ({commit}, data) {
    commit(types.SET_LIST_OF_REQUEST_TAGS, {data})
  }
}
const mutations = {
  [types.SET_REQUESTS_LIST] (state, {data}) {
    state.requestsList = data
  },
  [types.SET_REQUESTS_LIST_DECLINED] (state, {data}) {
    state.requestsListDeclined = data
  },
  [types.SET_REQUESTS_LIST_FORWARD] (state, {data}) {
    state.requestsListForward = data
  },
  [types.SET_LIST_OF_REQUEST_TAGS] (state, {data}) {
    state.listOfRequestTags = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/Requests/modules/store.js